'use client'

import clsx from 'clsx'
import { useInView } from 'framer-motion'
import { useEffect, useMemo, useRef, useState } from 'react'

import { Container } from './Container'

const reviews = [
  {
    title: 'Always rises to succeed',
    body: 'Kevin is a critical leader of any team, he is detail orientated and always rises to succeed when presented with new challenges. Over the years that I have worked with him he has been a pleasure to work with and a true professional',
    author: 'Mwambu Wanendeya',
    rating: 5,
    company: 'One',
    position: 'Director',
  },
  {
    title: 'Great blend of charm and knowledge',
    body: 'Kevin has taught me the art of simplicity. He can quickly engage the most important audiences with a great blend of charm and knowledge - all wrapped up in simple stories.',
    author: 'Jeremy Cochran',
    rating: 5,
    company: 'Global Business',
    position: 'CEO ',
  },
  // {
  //   title: 'Donald\’s diligence is admirable',
  //   body: 'and work ethic is unquestioned.',
  //   author: 'Ankur J',
  //   rating: 5,
  //   company: "New York Hedge Fund",
  //   position: "President"
  // },
  {
    title: 'Congratulations!',
    body: 'Craig is a driven and visionary individual and while he is supportive, he is also very blunt and honest. He has helped multiple founders to turn their ideas into tangible businesses and I am sure the AI FORGE will be a success as well!',
    author: 'Bomi Mosuro',
    rating: 5,
    company: 'City of Sounds',
    position: 'CEO',
  },
  // {
  //   title: 'Donald can impart significant value into startups',
  //   body: 'and he delivers an advantage to founders looking for guidance.',
  //   author: 'Gloria G',
  //   rating: 5,
  //   company: "",
  //   position: "Venture Capitalist "
  // },
  {
    title: 'Super Hard Working!!!',
    body: 'Craig Massey is a powerhouse entrepreneur. A kickass, no bullshit guy that is result driven and super hard working. He demands from others what he demands from himself - a work hard play hard ethic that explains why he is so successful, and why he is always smiling!',
    author: 'Sefi Carmel',
    rating: 5,
    position: 'CEO',
    company: 'Spheretrax',
  },
  {
    title: 'Invaluable Support.',
    body: "Craig's advice was invaluable in getting investor ready. He helped us focus our product, developed an appealing financial model and planned realistic and practical ways of growing the company. His knowledge on the startup ecosystem is unrivalled. He has personally scaled and exited his own companies, so he knows what he is talking about. I am so grateful for all his help.",
    author: 'Sashen Naicker',
    rating: 5,
    company: 'Mintelium',
    position: 'CEO',
  },
  {
    title: 'Impressive attention to detail',
    body: 'During my time with Craig, I was impressed by his ability to balance big-picture thinking with attention to detail. His energy and enthusiasm are amazing, and he is an inspiration to us all. Even after a big night out, he was fresh at 9am for financial modeling.',
    author: 'Matthew Foster',
    company: 'CosmosX',
    position: 'CEO',
    rating: 5,
    profile: 'https://i.ibb.co/FHRnq34/matthew-Foster-1.png',
  },
  {
    title: 'Ultimate dedication!',
    body: 'Miguel ensured that the team remained on track, worked cohesively through an organisational restructure and delivered against every milestone of a global implementation project.',
    author: 'Dana Mirabella',
    company: 'eCommerce',
    rating: 5,
    position: 'CRO',
  },
  // {
  //   title: 'Donald is the epitome of professionalism',
  //   body: 'He excels creating value driving solutions for companies seeking advisory.',
  //   author: 'Ashok H',
  //   rating: 5,
  //   company: "London Family Office",
  //   position: "Head"
  // },
  {
    title: 'Always adding value',
    body: 'Kevin did a great job coordinating a complex international project with dedication to perfect implementation and always adding value.',
    author: 'Max Bonpain',
    rating: 5,
    company: 'Fintech',
    position: 'Chief Marketing Officer',
  },
  {
    title: 'A leader, leading by example.',
    body: 'The project had very little margin for error and Miguel made sure that we pulled through, while keeping team morale high. Without his coordination of people and deliverables our project would never had made it off the ground.',
    author: 'Ricardo Herrera',
    company: 'PMO software',
    rating: 5,
    position: 'PM',
  },
  {
    title: 'Exceptional talent',
    body: 'Kevin has two exceptional talents he makes connections with ideas that create a WOW factor like no one else I have met and is excellent at creating and building relationships.',
    author: 'Graham Kemp',
    rating: 5,
    company: '',
    position: 'Exited Founder',
  },
  {
    title: 'Knows business inside out',
    body: 'Kevin knows business inside out and you will be hard pushed to find anyone that knows it better, when he speaks others listen. He makes it his business to be ahead of the game, with the latest information, data and results. Kevin surrounds himself, and attracts, the best possible people to achieve the best possible results.',
    author: 'Tom Eatenton',
    rating: 5,
    company: '',
    position: 'Founder & CEO',
  },
  {
    title: 'A truly agile program manager.',
    body: 'The nature of our product meant having to navigate through a lot of ambiguity. Miguel was able to pivot with the ever changing demands of the client, adapting in a way that remained focused on delivering a best in class product.',
    author: 'Emma Webley',
    rating: 5,
    company: 'Management consulting ',
    position: 'Associate Managing Director',
  },
]

function StarIcon(props) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
  )
}

function StarRating({ rating }) {
  return (
    <div className="flex">
      {[...Array(5).keys()].map((index) => (
        <StarIcon
          key={index}
          className={clsx(
            'h-5 w-5',
            rating > index ? 'fill-cyan-500' : 'fill-gray-300',
          )}
        />
      ))}
    </div>
  )
}

function Review({
  title,
  body,
  author,
  rating,
  company,
  position,
  className,
  ...props
}) {
  let animationDelay = useMemo(() => {
    let possibleAnimationDelays = ['0s', '0.1s', '0.2s', '0.3s', '0.4s', '0.5s']
    return possibleAnimationDelays[
      Math.floor(Math.random() * possibleAnimationDelays.length)
    ]
  }, [])

  return (
    <figure
      className={clsx(
        'animate-fade-in rounded-3xl bg-gray-900 p-6 opacity-0 shadow-md shadow-gray-900/5',
        className,
      )}
      style={{ animationDelay }}
      {...props}
    >
      <blockquote className="text-gray-100">
        <StarRating rating={rating} />
        <p className="mt-4 text-lg font-semibold leading-6 before:content-['“'] after:content-['”']">
          {title}
        </p>
        <p className="mt-3 text-base leading-7">{body}</p>
      </blockquote>
      <figcaption className="mt-3 text-sm text-gray-200 before:content-['–_']">
        {author} {position != '' && '|'} {position} {company != '' && '|'}{' '}
        {company}
      </figcaption>
    </figure>
  )
}

function splitArray(array, numParts) {
  let result = []
  for (let i = 0; i < array.length; i++) {
    let index = i % numParts
    if (!result[index]) {
      result[index] = []
    }
    result[index].push(array[i])
  }
  return result
}

function ReviewColumn({
  className,
  reviews,
  reviewClassName = () => {},
  msPerPixel = 0,
}) {
  let columnRef = useRef()
  let [columnHeight, setColumnHeight] = useState(0)
  let duration = `${columnHeight * msPerPixel}ms`

  useEffect(() => {
    let resizeObserver = new window.ResizeObserver(() => {
      if (columnRef.current) {
        setColumnHeight(columnRef.current.offsetHeight)
      }
    })
    if (columnRef.current) {
      resizeObserver.observe(columnRef.current)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  return (
    <div
      ref={columnRef}
      className={clsx('animate-marquee space-y-8 py-4', className)}
      style={{ '--marquee-duration': duration }}
    >
      {reviews.concat(reviews).map((review, reviewIndex) => (
        <Review
          key={reviewIndex}
          aria-hidden={reviewIndex >= reviews.length}
          className={reviewClassName(reviewIndex % reviews.length)}
          {...review}
        />
      ))}
    </div>
  )
}

function ReviewGrid() {
  let containerRef = useRef()
  let isInView = useInView(containerRef, { once: true, amount: 0.4 })
  let columns = splitArray(reviews, 3)
  columns = [columns[0], columns[1], splitArray(columns[2], 2)]

  return (
    <div
      ref={containerRef}
      className="relative -mx-4 mt-16 grid h-[49rem] max-h-[150vh] grid-cols-1 items-start gap-8 overflow-hidden px-4 sm:mt-20 md:grid-cols-2 lg:grid-cols-3"
    >
      {isInView && (
        <>
          <ReviewColumn
            reviews={[...columns[0], ...columns[2].flat(), ...columns[1]]}
            reviewClassName={(reviewIndex) =>
              clsx(
                reviewIndex >= columns[0].length + columns[2][0].length &&
                  'md:hidden',
                reviewIndex >= columns[0].length && 'lg:hidden',
              )
            }
            msPerPixel={10}
          />
          <ReviewColumn
            reviews={[...columns[1], ...columns[2][1]]}
            className="hidden md:block"
            reviewClassName={(reviewIndex) =>
              reviewIndex >= columns[1].length && 'lg:hidden'
            }
            msPerPixel={15}
          />
          <ReviewColumn
            reviews={columns[2].flat()}
            className="hidden lg:block"
            msPerPixel={10}
          />
        </>
      )}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black" />
    </div>
  )
}

export function Reviews() {
  return (
    <section
      id="reviews"
      aria-labelledby="reviews-title"
      className="pt-20 pb-16 sm:pt-32 sm:pb-24 bg-black"
    >
      <Container>
        <h2
          id="reviews-title"
          className="text-3xl font-medium tracking-tight text-gray-200 sm:text-center"
        >
          What People Say About Us
        </h2>
        <p className="mt-2 text-lg text-gray-400 sm:text-center">
          We have a long track record of hard work and total commitment to our
          business partners.
        </p>
        <ReviewGrid />
      </Container>
    </section>
  )
}
